var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyFilesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M17.1663 17.5C17.1663 16.337 17.1663 15.7555 17.0228 15.2824C16.6996 14.217 15.866 13.3834 14.8006 13.0602C14.3275 12.9167 13.746 12.9167 12.583 12.9167H8.41634C7.25337 12.9167 6.67189 12.9167 6.19872 13.0602C5.13339 13.3834 4.29971 14.217 3.97654 15.2824C3.83301 15.7555 3.83301 16.337 3.83301 17.5M14.2497 6.25C14.2497 8.32107 12.5707 10 10.4997 10C8.42861 10 6.74967 8.32107 6.74967 6.25C6.74967 4.17893 8.42861 2.5 10.4997 2.5C12.5707 2.5 14.2497 4.17893 14.2497 6.25Z",
    stroke: "#fff",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyFilesIcon);
export default __webpack_public_path__ + "static/media/myFilesIcon.8c43078326f178573d4be5842e3d3293.svg";
export { ForwardRef as ReactComponent };